import Vue from 'vue';

Vue.component('hidden-top-navigation', {
    mounted() {
        this.handleToggleVisibilityOnScroll();
    },

    methods: {
        handleToggleVisibilityOnScroll() {
            const header = document.querySelector('.hidden-top-navigation');
            const hero = document.querySelector('.model-microsite-hero');

            if (!header) return;

            window.addEventListener(
                'scroll',
                () => {
                    const heroVisible = hero
                        ? hero.getBoundingClientRect().bottom > 0
                        : false;

                    if (heroVisible) {
                        this.hideHeader(header);
                    } else {
                        this.showHeader(header);
                    }
                },
                { passive: true },
            );
        },

        showHeader(headerElement) {
            headerElement.classList.remove('hidden-top-navigation--hidden');
            headerElement.classList.add('hidden-top-navigation--visible');
        },

        hideHeader(headerElement) {
            headerElement.classList.remove('hidden-top-navigation--visible');
            headerElement.classList.add('hidden-top-navigation--hidden');
        },
    },
});
